import styled from 'styled-components'

export const StyledAccordionTitle = styled.div``
export const StyledAccordionContent = styled.div`
  padding: 1rem;
`

export const StyledAccordion = styled.div`
  padding: 1rem;

  &.normal-title ${StyledAccordionTitle} {
    text-transform: none;
  }
  ${StyledAccordionTitle} {
    text-transform: uppercase;
    font-size: 1.5rem;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.defaultTextColor};
    &:hover {
      color: ${({ theme }) => theme.colors.InfinitiLinkColor};
      font-weight: 600;
    }
  }
`

export const StyledCustomAccordion = styled.div`
  border-bottom: 0.1rem solid #e5e5e5;
  &:hover {
    border-bottom: 0.25rem solid ${({ theme }) => theme.colors.defaultTextColor};
  }
`
